// Data-visualisation palette for the analytics dashboards.
//
// These are NOT the brand tokens from tailwind.config.js, and that is deliberate.
// The brand gold (#A69961) was measured at OKLCH chroma 0.068 -- below the 0.10
// floor a mark needs to read as a hue rather than as grey -- and it sits only
// 13.8 normal-vision dE from the de-emphasis grey, under the 15 floor. Bars
// painted in it would have looked khaki-grey and been hard to separate from the
// muted rows around them.
//
// So: brand gold stays on the chrome (header, active nav, buttons); chart marks
// use the validated values below. Every one of these was checked with the
// dataviz validator against this app's actual white card surface, not eyeballed.
//
//   single-hue mark  #8F6F0C            chroma PASS, 4.9:1 on #FFFFFF
//   ordinal ramp     4 steps            monotone L, adjacent dL >= 0.06,
//                                       light end 2.37:1 (2:1 floor)
//   categorical      documented order   worst adjacent CVD dE 9.1,
//                                       normal-vision 19.6 -- contrast WARN, so
//                                       every categorical chart ships direct
//                                       labels AND a table view (the relief rule)
//   diverging        teal <-> red       CVD dE 14.0, normal-vision 30.4,
//                                       both >= 3:1, grey midpoint
//
// If you change any value here, re-run:
//   node scripts/validate_palette.js "<hex,...>" --mode light --surface "#ffffff"

// --- chart chrome -----------------------------------------------------------
export const chrome = {
  surface: '#FFFFFF',
  plane: '#FAF9F7',
  inkPrimary: '#1C1917',
  inkSecondary: '#57534E',
  muted: '#78716C',
  grid: '#EDEBE9',
  axis: '#D6D3D1',
};

// --- single hue: magnitude, nominal bars, single-series lines ---------------
// Nominal bars all take this ONE colour. Colouring them by their own value would
// spend the identity channel re-encoding what bar length already shows.
export const mark = '#8F6F0C';
export const markSoft = '#C4A63A';
export const deEmphasis = '#D6D3D1';

// --- ordinal ramp: ordered buckets (light -> dark) --------------------------
export const ordinal = ['#C4A63A', '#A8871A', '#8F6F0C', '#735908'];

// --- categorical: identity, assigned in fixed order, never cycled -----------
// Fixed order is the CVD-safety mechanism. A 6th+ series folds into "Other"
// rather than getting a generated hue.
export const categorical = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4'];

// --- diverging: polarity around a baseline ----------------------------------
export const diverging = {
  positive: '#0D9488',
  negative: '#B91C1C',
  midpoint: '#EDEBE9',
};

// --- status: state, ALWAYS paired with an icon + label ----------------------
export const status = {
  good: '#15803D',
  warning: '#B45309',
  critical: '#B91C1C',
};

// Series colour follows the entity, never its rank, so a filter that changes the
// row count does not repaint the survivors.
export const seriesColor = (index) => categorical[index % categorical.length];
